export default __webpack_public_path__ + "static/media/default-profile.a107eb5a.svg";